<template>
  <div class="textMessage" :class="[$style.replyMessageContent, $style[$attrs.theme]]">
    <blockquote v-if="showBlockquote">
      <template v-if="replyMessage.content.msgtype === $options.msgTypes.text">
        <a href="#" :class="$style.replyMessageContentUsername">
          {{ repliedUserName }}
        </a>
        <br />
        <p :class="$style.replyMessageContentText" v-html="formattedMessage"></p>
      </template>
      <template v-if="replyMessage.content.msgtype === $options.msgTypes.image">
        <div :class="$style.replyMessageContentImage">
          <img :src="cuttingImage" alt="" />
          <div style="padding-left: 5px">
            <strong :class="$style.replyMessageContentUsername">{{ repliedUserName }}</strong>
            <br />
            <span>{{ $t('attachment.image') }}</span>
          </div>
        </div>
      </template>
      <template v-if="replyMessage.content.msgtype === $options.msgTypes.file">
        <div :class="$style.replyMessageContentFile">
          <div :class="$style.iconWrap">
            <BaseIcon name="file" :class="$style.icon" />
          </div>
          <div style="padding-left: 5px">
            <strong :class="$style.replyMessageContentUsername">{{ repliedUserName }}</strong>
            <br />
            <span>{{ replyMessage.content.body }}</span>
          </div>
        </div>
      </template>
      <template v-if="replyMessage.content.msgtype === $options.msgTypes.audio">
        <div :class="$style.replyMessageContentFile">
          <div :class="$style.iconWrap">
            <BaseIcon name="play" :class="$style.icon" />
          </div>
          <div style="padding-left: 5px">
            <strong :class="$style.replyMessageContentUsername">{{ repliedUserName }}</strong>
            <br />
            <span>{{ replyMessage.content.body }}</span>
          </div>
        </div>
      </template>
      <template v-if="replyMessage.content.msgtype === $options.msgTypes.video">
        <div :class="$style.replyMessageContentImage">
          <div :class="$style.iconWrap">
            <BaseIcon name="video" :class="$style.icon" />
          </div>
          <div style="padding-left: 5px">
            <strong :class="$style.replyMessageContentUsername">{{ repliedUserName }}</strong>
            <br />
            <span>{{ $t('attachment.video') }}</span>
          </div>
        </div>
      </template>
      <template v-if="replyMessage.content.msgtype === $options.msgTypes.gif">
        <div :class="$style.replyMessageContentImage">
          <img :src="replyMessage.content.url" alt="" />
          <div style="padding-left: 5px">
            <strong :class="$style.replyMessageContentUsername">{{ repliedUserName }}</strong>
            <br />
            <span>{{ $t('gif') }}</span>
          </div>
        </div>
      </template>
    </blockquote>
    <MessageContent
      v-bind="{ message: originMessage, theme, isForwarded: false }"
      @show-translate="$event => (showTranslate = $event)"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MessageContent from './MessageContentMatrix'

import { msgTypes } from '@/helpers/variables'

export default {
  name: 'MatrixReplyMessageContent',
  msgTypes,
  props: {
    originMessage: {
      type: Object,
      default: () => {},
      required: true
    },
    replyMessage: {
      type: Object,
      default: () => {},
      required: true
    },
    isPrevMessage: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    MessageContent
  },
  data: () => ({
    showTranslate: false
  }),
  computed: {
    ...mapGetters({
      roomMembers: 'matrix/roomMembers'
    }),
    showBlockquote () {
      if (this.theme === 'green') return !this.isPrevMessage
      return this.originMessage.content.isTranslated ? this.showTranslate : true
    },
    formattedMessage () {
      if (this.replyMessage.content.new_body && !this.showOriginal) {
        return this.replyMessage.content.new_body
      }
      if (this.replyMessage.content.formatted_body && this.replyMessage.content['m.relates_to']) {
        return this.replyMessage.content.formatted_body.split('</mx-reply>')[1]
      }
      if (this.replyMessage.content.formatted_body) {
        return this.replyMessage.content.formatted_body
      }
      return this.replyMessage.content.body
    },
    cuttingImage () {
      if (this.replyMessage.content.msgtype !== msgTypes.image) return
      return window.matrixSDK.mxcUrlToHttp(this.replyMessage.content.url)
    },
    videoThumbnail () {
      if (this.replyMessage.content.msgtype !== msgTypes.video) return
      return window.matrixSDK.mxcUrlToHttp(this.replyMessage.content.info.thumbnail_url)
    },
    repliedUserName () {
      const user = this.roomMembers.find(e => e.id === this.replyMessage.sender)
      return user ? user.display_name : ''
    }
  }
}
</script>
<style module lang="scss">
.green {
  .replyMessageContentUsername {
    color: $white;
  }
  .iconWrap {
    background-color: rgba($white, 0.15);
  }
  .icon {
    color: $white;
  }
}

.replyMessageContentUsername {
  font-weight: 600;
}
.replyMessageContentFile {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.replyMessageContent {
  display: block;
  &Username {
    text-transform: capitalize;
    pointer-events: none;
  }
  &Text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    blockquote {
      border-left: none;
      padding-left: 0;
    }
  }
  &Image {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    strong {
      color: $green;
    }
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
    }
    span {
      display: block;
      margin-top: 3px;
    }
  }
}
.iconWrap {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($main-bg-colored, 0.15);
  flex-shrink: 0;
  position: relative;
}
.icon {
  font-size: 20px;
  color: $text-colored;
}
</style>
